import { initTitleLineRevealOnView } from '../parts/highlight-sweep';
initTitleLineRevealOnView('.block-page-hero__title', '.js--gradient-highlight-page-hero');
